/** Matches WooCommerce's concrete and "any value" variation attributes. */
export const selectSetVariant = (variants, selections) => variants.find((variant) => (
    Object.entries(variant.attributes).every(([name, value]) => (
        selections[name] && (value === '' || value === selections[name])
    ))
)) || null;

/** Earlier attributes constrain later ones, so changing metal never creates a dead end. */
export const resolveSetOptions = (variants, attributes, selections) => {
    const picked = {};
    const available = {};
    for (const attribute of attributes) {
        available[attribute.name] = attribute.options.filter((option) => variants.some((variant) => (
            Object.entries({ ...picked, [attribute.name]: option }).every(([name, value]) => (
                !value || !variant.attributes[name] || variant.attributes[name] === value
            ))
        )));
        const options = available[attribute.name];
        picked[attribute.name] = options.includes(selections[attribute.name])
            ? selections[attribute.name]
            : (options.length === 1 ? options[0] : '');
    }
    return {
        selections: picked,
        available,
        variant: attributes.every(({ name }) => picked[name]) ? selectSetVariant(variants, picked) : null,
    };
};
